import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import classNames from "classnames";
import styles from "./PrivateLayout.module.scss";
import PrivateNavigation from "../../components/PrivateNavigation/PrivateNavigation";
import { selectLoggedIn } from "../../store/slices/auth/slice";
import { selectLoggedInUserRole } from "../../store/slices/user/slice";
import { PERMISSIONS_FOT_ROUTES } from "../../utils/constants";
import { ModalSettings, ModalNotifications, Chip } from "../../components";
import { selectLoggedInUserDetails } from "../../store/slices/user/slice";
import { fetchNotifications } from "../../store/slices/notifications/asyncThunks";
import { notifyError } from "../../utils/notify";
import { ReactComponent as Notification } from "../../assets/icons/notifications.svg";
import { ReactComponent as MenuIcon } from "../../assets/icons/menu.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/x.svg";

const PrivateLayout = () => {
  const isAuthenticated = useSelector(selectLoggedIn);
  const modalRef = useRef();
  const modalNotifRef = useRef();
  const dispatch = useDispatch();
  const location = useLocation();

  const logedInUserDetails = useSelector(selectLoggedInUserDetails);

  const userRole = useSelector(selectLoggedInUserRole);
  const [userHasRequiredRole, setUserHasRequiredRole] = useState(false);

  const showNotificationsModal = () => {
    dispatch(fetchNotifications()).then((promise) => {
      if (promise.type.includes("fulfilled")) {
        modalNotifRef.current.show();
      } else {
        notifyError(promise.error.message);
      }
    });
  };

  useEffect(() => {
    if (PERMISSIONS_FOT_ROUTES[location.pathname]) {
      if (PERMISSIONS_FOT_ROUTES[location.pathname].includes(userRole)) {
        setUserHasRequiredRole(true);
      } else {
        setUserHasRequiredRole(false);
      }
    } else {
      setUserHasRequiredRole(true);
    }
  }, [location]);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return isAuthenticated ? (
    <div className={classNames(styles.container)}>
      <PrivateNavigation />
      <div className={classNames(styles.screenContainer)}>
        <div className={styles.topBar}>
          {!isMobileMenuOpen ? (
            <div
              className={styles.menuIcon}
              onClick={() => setIsMobileMenuOpen(true)}
            >
              <MenuIcon />
            </div>
          ) : (
            <div
              className={styles.menuIcon}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <CloseIcon />
            </div>
          )}
          <div className={styles.bottomContainerProfile}>
            <Notification onClick={() => showNotificationsModal()} />
            <div
              className={styles.userContainer}
              onClick={() => modalRef.current.show()}
            >
              <Chip
                {...logedInUserDetails}
                img={logedInUserDetails.profilePhoto}
              />
              {logedInUserDetails.firstName + " " + logedInUserDetails.lastName}
            </div>
          </div>
        </div>
        {userHasRequiredRole ? <Outlet /> : <div>FORBIDEN</div>}
      </div>
      <ModalSettings modalRef={modalRef} userDetails={logedInUserDetails} />
      <ModalNotifications modalRef={modalNotifRef} />
      {isMobileMenuOpen && (
        <div
          className={styles.mobileMenuModal}
          onClick={() => setIsMobileMenuOpen(false)}
        >
          <div
            className={styles.mobileMenuContent}
            onClick={(e) => e.stopPropagation()}
          >
            <PrivateNavigation isMobile />
          </div>
        </div>
      )}
    </div>
  ) : (
    <Navigate to="/login-school" state={{ from: location }} replace />
  );
};

export default PrivateLayout;
